"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var _iconsMaterial = require("@mui/icons-material");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _Style = require("../../style/Style");
var _lesson = require("../../store/lesson");
var _Lesson = require("../../model/Lesson");
var _UserLesson = require("../../model/UserLesson");
var _user = require("../../store/user");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//import { Button } from '@mui/base';
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const [lesson, setLesson] = (0, _react.useState)(new _Lesson.Lesson());
  const [userLesson, setUserLesson] = (0, _react.useState)(new _UserLesson.UserLesson());
  const lastUpdateTime = new Date();
  const {
    setIsLoading,
    setToastText,
    setToastOpen,
    onLoggedIn,
    setOnLoggedIn
  } = (0, _common.useCommonStore)();
  const {
    currentUser
  } = (0, _user.useUserStore)();
  const {
    lessons,
    fetchLessons,
    deleteLesson,
    errors,
    isPassed,
    score,
    userAnswers,
    resetAnswers,
    setUserAnswers
  } = (0, _lesson.useLessonStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      if (!currentUser || !currentUser.id) {
        setToastText('ユーザー情報が見つかりませんでした。再度ログインしてください。');
        setToastOpen(true);
        setLocation('/login');
        return;
      }
      if (!currentUser.companyId) {
        setToastText('ユーザー情報位問題があります。再度ログインしてください。');
        setToastOpen(true);
        setLocation('/login');
        return;
      }
      if (!props.courseId) {
        setLocation('/courses');
        setToastText('コースが見つかりませんでした。');
        setToastOpen(true);
        return;
      }
      if (!props.lessonId) {
        setLocation(`/course/detail/${props.courseId}`);
        setToastText('教材が見つかりませんでした。');
        setToastOpen(true);
        return;
      }
      setIsLoading(true);
      const newLesson = await _Lesson.Lesson.getByID(props.lessonId);
      const currentUserLesson = await _UserLesson.UserLesson.getByID(currentUser.id, props.lessonId);
      if (!currentUserLesson.id) {
        userLesson.init(currentUser.id, currentUser.companyId, props.courseId, props.lessonId);
      }
      if (!currentUserLesson.isCompleted) {
        setLocation(`/course/detail/${props.courseId}`);
        setToastText(`単元「${lesson.name}」を修了していないため、修了テストが開始できません。`);
        setToastOpen(true);
        return;
      }
      if (userAnswers.length === 0) {
        setLocation(`/course/detail/${props.courseId}`);
        return;
      }
      setUserLesson(currentUserLesson);
      await newLesson.fetchExamQuestions();
      setLesson(newLesson);
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    direction: "column",
    spacing: 2,
    alignItems: 'center',
    justifyContent: 'center',
    ...stylex.props(_Style.wrapper.main),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Link, {
      href: `/course/detail/${lesson.courseId}`,
      ...stylex.props(_Style.textStyle.clearLinkDecoration),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.buttonStyle.secondary),
        children: "\u5358\u5143\u4E00\u89A7\u306B\u623B\u308B"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "row",
      alignItems: 'center',
      justifyContent: 'center',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.chipStyle.common, userLesson.isPassedExam ? _Style.chipStyle.active : _Style.chipStyle.inactive),
        children: userLesson.isPassedExamText
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: ["\u5358\u5143\u300C", lesson.name, "\u300D \u4FEE\u4E86\u30C6\u30B9\u30C8\u7D50\u679C"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ...stylex.props(_Style.textStyle.paragraph1),
      children: lesson.detail
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: ["\u53D7\u8B1B\u958B\u59CB\u65E5\u6642: ", userLesson.startedAtText]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: ["\u53D7\u8B1B\u5B8C\u4E86\u65E5\u6642: ", userLesson.completedAtText]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: ["\u4FEE\u4E86\u65E5\u6642: ", userLesson.examPassedAtText]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: 'column',
      ...stylex.props(_Style.textStyle.p1b, _Style.wrapper.stretchW, _Style.wrapper.examResult, isPassed ? _Style.wrapper.examPassed : _Style.wrapper.examFailed),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        ...stylex.props(_Style.wrapper.flexCenter),
        children: [isPassed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.CheckCircleRounded, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.ErrorRounded, {}), "\u3000", userLesson.examScoreMax, "\u554F\u4E2D ", score, "\u554F \u304C\u6B63\u89E3\u3067\u3057\u305F\u3002 ", isPassed ? "合格です" : "不合格です", " ", !isPassed && userLesson.isPassedExam && "(あなたは既に合格済みです)", " \u3002"]
      }), userLesson.isPassedExam && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
          container: true,
          direction: "row",
          justifyContent: 'center',
          alignItems: 'center',
          spacing: 4,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
            startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.PictureAsPdf, {}),
            onClick: () => {
              setToastText('サンプルアカウントでは修了証をダウンロードできません。');
              setToastOpen(true);
            },
            ...stylex.props(isPassed ? _Style.buttonStyle.primary : _Style.buttonStyle.secondary),
            children: "\u4FEE\u4E86\u8A3C\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
            startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.Email, {}),
            onClick: () => {
              setToastText('サンプルアカウントでは修了証をダウンロードできません。');
              setToastOpen(true);
            },
            ...stylex.props(isPassed ? _Style.buttonStyle.primary : _Style.buttonStyle.secondary),
            children: "\u4FEE\u4E86\u8A3C\u3092\u30E1\u30FC\u30EB\u3067\u9001\u4FE1"
          })]
        })
      })]
    }), lesson.examQuestions && lesson.examQuestions.length > 0 && lesson.examQuestions.map((question, index) => {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
        container: true,
        direction: "column",
        spacing: 1,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
          container: true,
          direction: "row",
          justifyContent: 'flex-start',
          alignItems: "center",
          ...stylex.props(_Style.textStyle.h3),
          children: [userAnswers[index] === question.correctAnswerIndex ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            ...stylex.props(_Style.iconStyle.correct),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.CheckCircleRounded, {})
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            ...stylex.props(_Style.iconStyle.incorrect),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_iconsMaterial.ErrorRounded, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            children: [index + 1, ". ", question.question]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Stack, {
          direction: "column",
          spacing: 2,
          ...stylex.props(_Style.wrapper.stretchW),
          children: [question.answers.map((answer, answerIndex) => {
            const isChecked = userAnswers[index] === answerIndex;
            const isCorrect = answerIndex === question.correctAnswerIndex;
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              ...stylex.props(isCorrect ? _Style.buttonStyle.primary : _Style.buttonStyle.secondary),
              children: [answerIndex + 1, ". ", answer, " ", isChecked && "　(あなたの回答)"]
            });
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            ...stylex.props(_Style.textStyle.p1b),
            children: ["\u6B63\u89E3: ", question.correctAnswerIndex + 1]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            ...stylex.props(_Style.textStyle.p1),
            children: ["\u89E3\u8AAC: ", question.explanation]
          })]
        })]
      });
    }), !isPassed && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      direction: "row",
      justifyContent: 'center',
      alignItems: 'center',
      ...stylex.props(_Style.wrapper.stretchW, _Style.marginStyle.top),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
        onClick: async () => {
          if (!window.confirm('修了テストを再度開始しますか？')) return;
          await resetAnswers();
          setLocation(`/course/${lesson.courseId}/lesson/${userLesson.lessonId}/exam`);
        },
        ...stylex.props(_Style.textStyle.h3, _Style.buttonStyle.primary, _Style.wrapper.stretchW),
        children: "\u3000\u4FEE\u4E86\u30C6\u30B9\u30C8\u306B\u518D\u30C1\u30E3\u30EC\u30F3\u30B8\u3059\u308B"
      })
    })]
  });
}; // <div {...stylex.props(chipStyle.common, chipStyle.inactive)}>未受講</div>*/
var _default = exports.default = App;